<template lang="pug">
div
    select.form-control.c-select(
        name="supplie",
        :class="className",
        @change="onSelect"
    )
        option(
            :value="null",
            :selected="value == null"
        ) {{ placeholder }}
        
        option(
            v-for="supplier in supplierList",
            :value="supplier.id",
            :selected="value == supplier.id"
        ) {{ supplier.name }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    props: {
        className: {
            type: String,
            default: '',
        },

        placeholder: {
            type: String,
            default: 'Select Supplier',
        },

        value: {
            type: Number,
            default: null,
        },
    },

    computed: {
        api() {
            return Laroute.route('data_api.suppliers');
        },

        ...mapGetters('supplier', ['supplierList']),
    },

    mounted() {
        this.getSupplierList();
    },

    methods: {
        ...mapActions('supplier', ['getSupplierList']),

        onSelect(e) {
            const value =
                e.target.value != null && e.target.value.trim() != ''
                    ? parseInt(e.target.value)
                    : null;

            this.$emit('input', value);
            this.$emit('change', value);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/selector/supplier-selector.vue